import { render, staticRenderFns } from "./ByProviders.vue?vue&type=template&id=c9cf6d68&"
import script from "./ByProviders.vue?vue&type=script&lang=js&"
export * from "./ByProviders.vue?vue&type=script&lang=js&"
import style0 from "./ByProviders.vue?vue&type=style&index=0&id=c9cf6d68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports